//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import insureDetails from '../../../components/layer/insureDetails.vue'
    import { FactoryUtils } from '../../../utils/FactoryUtils'
import  Details  from "@/views/stencil/Insurance/components/monthly/details.vue";

    export default {
        name: "guarantee",
        data(){
            return {
                content:[],
                moduleName:null,
                show:false
            }
        },
        components:{
            insureDetails,
            Details
        },
        props: {
            contentList: {
                type: Object,
                default() { return {}}
            },
            type:{
                type:String,
                default:'tk_irok'
            }
        },
        created() {
                this.moduleName = this.contentList.module_name
                this.content = this.contentList.content_list
            
        },
        methods: {
           goDetails(){
                this.STATISTICS('click','sybao_ins_proinfo_ensuredetail_click')

                if(this.type == 'ht_irok_plus'){
                    this.show = false;
                    this.$nextTick(()=>{
                        this.show = true
                    })
                    return
                }else{
                     FactoryUtils.planDetails().then(res =>{
                        if(res.insureDetails){
                            this.$refs.insureDetails.showToast()
                        }else{
                            this.$router.push({
                                path: "/planDetails",
                                query:{'templateFlag':this.type}
                            });
                        }
                        
                    })
                }   
                
           },
           beautyClick(){ //点击医疗美容项目表
             this.STATISTICS('click','sybao_ins_ensuredetail_beautyprojects_click')
           },
           hospitalsClick(){ //点击服务医院表
             this.STATISTICS('click','sybao_ins_ensuredetail_hospitals_click')
           },
           diseaseClick(){ //100中重大疾病
             this.STATISTICS('click','sybao_ins_ensuredetail_disease_click')

           }
        },
    }
